import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["id", "value", "defaultValue", "name", "onChange", "by", "disabled"],
    _excluded2 = ["id", "value", "disabled"];

var _Ce;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import g, { createContext as J, useContext as V, useMemo as P, useReducer as le, useRef as j, useEffect as se } from "react";
import { forwardRefWithAs as X, render as q, compact as ue } from '../../utils/render.js';
import { useId as Q } from '../../hooks/use-id.js';
import { match as de } from '../../utils/match.js';
import { useIsoMorphicEffect as ce } from '../../hooks/use-iso-morphic-effect.js';
import { Keys as A } from '../../components/keyboard.js';
import { focusIn as Y, Focus as M, FocusResult as Z, sortByDomNode as fe } from '../../utils/focus-management.js';
import { useFlags as Te } from '../../hooks/use-flags.js';
import { Label as me, useLabels as z } from '../../components/label/label.js';
import { Description as ye, useDescriptions as ee } from '../../components/description/description.js';
import { useTreeWalker as Re } from '../../hooks/use-tree-walker.js';
import { useSyncRefs as te } from '../../hooks/use-sync-refs.js';
import { Hidden as be, Features as ge } from '../../internal/hidden.js';
import { attemptSubmit as Oe, objectToFormEntries as Ee } from '../../utils/form.js';
import { getOwnerDocument as ve } from '../../utils/owner.js';
import { useEvent as O } from '../../hooks/use-event.js';
import { useControllable as Pe } from '../../hooks/use-controllable.js';
import { isDisabledReactIssue7711 as re } from '../../utils/bugs.js';
import { useLatestValue as Ae } from '../../hooks/use-latest-value.js';
import { useDisposables as De } from '../../hooks/use-disposables.js';

var Ge = function (t) {
  return t[t.RegisterOption = 0] = "RegisterOption", t[t.UnregisterOption = 1] = "UnregisterOption", t;
}(Ge || {});

var Ce = (_Ce = {}, _defineProperty(_Ce, 0, function _(r, o) {
  var t = [].concat(_toConsumableArray(r.options), [{
    id: o.id,
    element: o.element,
    propsRef: o.propsRef
  }]);
  return _objectSpread(_objectSpread({}, r), {}, {
    options: fe(t, function (a) {
      return a.element.current;
    })
  });
}), _defineProperty(_Ce, 1, function _(r, o) {
  var t = r.options.slice(),
      a = r.options.findIndex(function (f) {
    return f.id === o.id;
  });
  return a === -1 ? r : (t.splice(a, 1), _objectSpread(_objectSpread({}, r), {}, {
    options: t
  }));
}), _Ce),
    B = J(null);
B.displayName = "RadioGroupDataContext";

function oe(r) {
  var o = V(B);

  if (o === null) {
    var t = new Error("<".concat(r, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, oe), t;
  }

  return o;
}

var $ = J(null);
$.displayName = "RadioGroupActionsContext";

function ne(r) {
  var o = V($);

  if (o === null) {
    var t = new Error("<".concat(r, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, ne), t;
  }

  return o;
}

function ke(r, o) {
  return de(o.type, Ce, r, o);
}

var Le = "div";

function he(r, o) {
  var t = Q(),
      _r$id = r.id,
      a = _r$id === void 0 ? "headlessui-radiogroup-".concat(t) : _r$id,
      f = r.value,
      E = r.defaultValue,
      _ = r.name,
      v = r.onChange,
      _r$by = r.by,
      D = _r$by === void 0 ? function (e, i) {
    return e === i;
  } : _r$by,
      _r$disabled = r.disabled,
      G = _r$disabled === void 0 ? !1 : _r$disabled,
      H = _objectWithoutProperties(r, _excluded),
      T = O(typeof D == "string" ? function (e, i) {
    var n = D;
    return (e == null ? void 0 : e[n]) === (i == null ? void 0 : i[n]);
  } : D),
      _le = le(ke, {
    options: []
  }),
      _le2 = _slicedToArray(_le, 2),
      C = _le2[0],
      k = _le2[1],
      p = C.options,
      _z = z(),
      _z2 = _slicedToArray(_z, 2),
      w = _z2[0],
      U = _z2[1],
      _ee = ee(),
      _ee2 = _slicedToArray(_ee, 2),
      m = _ee2[0],
      L = _ee2[1],
      h = j(null),
      N = te(h, o),
      _Pe = Pe(f, v, E),
      _Pe2 = _slicedToArray(_Pe, 2),
      l = _Pe2[0],
      F = _Pe2[1],
      u = P(function () {
    return p.find(function (e) {
      return !e.propsRef.current.disabled;
    });
  }, [p]),
      y = P(function () {
    return p.some(function (e) {
      return T(e.propsRef.current.value, l);
    });
  }, [p, l]),
      d = O(function (e) {
    var n;
    if (G || T(e, l)) return !1;
    var i = (n = p.find(function (c) {
      return T(c.propsRef.current.value, e);
    })) == null ? void 0 : n.propsRef.current;
    return i != null && i.disabled ? !1 : (F == null || F(e), !0);
  });

  Re({
    container: h.current,
    accept: function accept(e) {
      return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(e) {
      e.setAttribute("role", "none");
    }
  });
  var W = O(function (e) {
    var i = h.current;
    if (!i) return;
    var n = ve(i),
        c = p.filter(function (s) {
      return s.propsRef.current.disabled === !1;
    }).map(function (s) {
      return s.element.current;
    });

    switch (e.key) {
      case A.Enter:
        Oe(e.currentTarget);
        break;

      case A.ArrowLeft:
      case A.ArrowUp:
        if (e.preventDefault(), e.stopPropagation(), Y(c, M.Previous | M.WrapAround) === Z.Success) {
          var b = p.find(function (K) {
            return K.element.current === (n == null ? void 0 : n.activeElement);
          });
          b && d(b.propsRef.current.value);
        }

        break;

      case A.ArrowRight:
      case A.ArrowDown:
        if (e.preventDefault(), e.stopPropagation(), Y(c, M.Next | M.WrapAround) === Z.Success) {
          var _b = p.find(function (K) {
            return K.element.current === (n == null ? void 0 : n.activeElement);
          });

          _b && d(_b.propsRef.current.value);
        }

        break;

      case A.Space:
        {
          e.preventDefault(), e.stopPropagation();
          var s = p.find(function (b) {
            return b.element.current === (n == null ? void 0 : n.activeElement);
          });
          s && d(s.propsRef.current.value);
        }
        break;
    }
  }),
      x = O(function (e) {
    return k(_objectSpread({
      type: 0
    }, e)), function () {
      return k({
        type: 1,
        id: e.id
      });
    };
  }),
      R = P(function () {
    return _objectSpread({
      value: l,
      firstOption: u,
      containsCheckedOption: y,
      disabled: G,
      compare: T
    }, C);
  }, [l, u, y, G, T, C]),
      I = P(function () {
    return {
      registerOption: x,
      change: d
    };
  }, [x, d]),
      ie = {
    ref: N,
    id: a,
    role: "radiogroup",
    "aria-labelledby": w,
    "aria-describedby": m,
    onKeyDown: W
  },
      ae = P(function () {
    return {
      value: l
    };
  }, [l]),
      S = j(null),
      pe = De();
  return se(function () {
    S.current && E !== void 0 && pe.addEventListener(S.current, "reset", function () {
      d(E);
    });
  }, [S, d]), g.createElement(L, {
    name: "RadioGroup.Description"
  }, g.createElement(U, {
    name: "RadioGroup.Label"
  }, g.createElement($.Provider, {
    value: I
  }, g.createElement(B.Provider, {
    value: R
  }, _ != null && l != null && Ee(_defineProperty({}, _, l)).map(function (_ref, n) {
    var _ref2 = _slicedToArray(_ref, 2),
        e = _ref2[0],
        i = _ref2[1];

    return g.createElement(be, _objectSpread({
      features: ge.Hidden,
      ref: n === 0 ? function (c) {
        var s;
        S.current = (s = c == null ? void 0 : c.closest("form")) != null ? s : null;
      } : void 0
    }, ue({
      key: e,
      as: "input",
      type: "radio",
      checked: i != null,
      hidden: !0,
      readOnly: !0,
      name: e,
      value: i
    })));
  }), q({
    ourProps: ie,
    theirProps: H,
    slot: ae,
    defaultTag: Le,
    name: "RadioGroup"
  })))));
}

var Fe = function (t) {
  return t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active", t;
}(Fe || {});

var xe = "div";

function _e(r, o) {
  var x;

  var t = Q(),
      _r$id2 = r.id,
      a = _r$id2 === void 0 ? "headlessui-radiogroup-option-".concat(t) : _r$id2,
      f = r.value,
      _r$disabled2 = r.disabled,
      E = _r$disabled2 === void 0 ? !1 : _r$disabled2,
      _ = _objectWithoutProperties(r, _excluded2),
      v = j(null),
      D = te(v, o),
      _z3 = z(),
      _z4 = _slicedToArray(_z3, 2),
      G = _z4[0],
      H = _z4[1],
      _ee3 = ee(),
      _ee4 = _slicedToArray(_ee3, 2),
      T = _ee4[0],
      C = _ee4[1],
      _Te = Te(1),
      k = _Te.addFlag,
      p = _Te.removeFlag,
      w = _Te.hasFlag,
      U = Ae({
    value: f,
    disabled: E
  }),
      m = oe("RadioGroup.Option"),
      L = ne("RadioGroup.Option");

  ce(function () {
    return L.registerOption({
      id: a,
      element: v,
      propsRef: U
    });
  }, [a, L, v, r]);
  var h = O(function (R) {
    var I;
    if (re(R.currentTarget)) return R.preventDefault();
    L.change(f) && (k(2), (I = v.current) == null || I.focus());
  }),
      N = O(function (R) {
    if (re(R.currentTarget)) return R.preventDefault();
    k(2);
  }),
      l = O(function () {
    return p(2);
  }),
      F = ((x = m.firstOption) == null ? void 0 : x.id) === a,
      u = m.disabled || E,
      y = m.compare(m.value, f),
      d = {
    ref: D,
    id: a,
    role: "radio",
    "aria-checked": y ? "true" : "false",
    "aria-labelledby": G,
    "aria-describedby": T,
    "aria-disabled": u ? !0 : void 0,
    tabIndex: function () {
      return u ? -1 : y || !m.containsCheckedOption && F ? 0 : -1;
    }(),
    onClick: u ? void 0 : h,
    onFocus: u ? void 0 : N,
    onBlur: u ? void 0 : l
  },
      W = P(function () {
    return {
      checked: y,
      disabled: u,
      active: w(2)
    };
  }, [y, u, w]);
  return g.createElement(C, {
    name: "RadioGroup.Description"
  }, g.createElement(H, {
    name: "RadioGroup.Label"
  }, q({
    ourProps: d,
    theirProps: _,
    slot: W,
    defaultTag: xe,
    name: "RadioGroup.Option"
  })));
}

var we = X(he),
    Ie = X(_e),
    mt = Object.assign(we, {
  Option: Ie,
  Label: me,
  Description: ye
});
export { mt as RadioGroup };